import { createActionGroup, props } from '@ngrx/store';
import { Quote } from '@zero/shared/util-models';
import { EasyTradingMatrix, UnderlyingSegment } from '../entities/easy-trading-matrix.entity';
import { Underlying } from '../entities/underlying.entity';

export const tradingToolsActions = createActionGroup({
  source: 'Trading Tools',
  events: {
    'Load Underlyings': props<{ segment: UnderlyingSegment }>(),
    'Load Easy Trading Matrix': props<{ isin: string }>(),
    'Select Underlying': props<{ isin: string }>(),
    'Update Underlying Quotes': props<{ quotes: Record<string, Quote>; historicQuotes: Record<string, Quote> }>(),
  },
});

export const tradingToolsApiActions = createActionGroup({
  source: 'Trading Tools API',
  events: {
    'Load Underlyings Success': props<{ underlyings: Underlying[] }>(),
    'Load Underlyings Failure': props<{ error: string }>(),
    'Load Easy Trading Matrix Success': props<{ matrix: EasyTradingMatrix }>(),
    'Load Easy Trading Matrix Failure': props<{ error: string }>(),
  },
});
